import { cn } from '../../lib/cn';
import { CompanyLogo } from '../atoms';

const SIZES = {
  /** Header: the product name drops on phones so the client switcher keeps its room. */
  md: { logo: 18, divider: 'h-5', text: 'text-[15px]', productName: 'hidden sm:inline' },
  /** Sign-in page. */
  lg: { logo: 26, divider: 'h-7', text: 'text-xl', productName: '' },
} as const;

interface WordmarkProps {
  /** On the band header (white logo); otherwise for light surfaces. */
  onBand?: boolean;
  size?: keyof typeof SIZES;
}

/** Company logo + product name. */
export function Wordmark({ onBand = true, size = 'md' }: WordmarkProps) {
  const s = SIZES[size];
  return (
    <span className="inline-flex items-center gap-3">
      <CompanyLogo inverse={onBand} height={s.logo} />
      <span className={cn('w-px', s.divider, s.productName, onBand ? 'bg-band-fg-muted/50' : 'bg-line-strong')} aria-hidden />
      <span
        className={cn(
          'font-display font-semibold tracking-[-0.01em]',
          s.text,
          s.productName,
          onBand ? 'text-band-fg-secondary' : 'text-fg-secondary',
        )}
      >
        Monitor
      </span>
    </span>
  );
}
